import {
  FormParereViewComponent
} from "../../../../tributario/fascicoloFormShared/form-parere/view/form-parere-view.component";
import {FormParereComponent} from "../../../../tributario/fascicoloFormShared/form-parere/form-parere.component";
import {
  FormAppelloViewComponent
} from "../../../../tributario/fascicoloFormShared/form-appello/view/form-appello-view.component";
import {FormAppelloComponent} from "../../../../tributario/fascicoloFormShared/form-appello/form-appello.component";
import {
  FormOrdinarioComponent
} from "../../../../tributario/fascicoloFormShared/form-ordinario/form-ordinario.component";
import {
  FormOrdinarioViewComponent
} from "../../../../tributario/fascicoloFormShared/form-ordinario/view/form-ordinario-view.component";
import {
  FormRicorsoCassazioneViewComponent
} from "../../../../tributario/fascicoloFormShared/form-ricorso-cassazione/view/form-ricorso-cassazione-view.component";
import {
  FormRicorsoCassazioneComponent
} from "../../../../tributario/fascicoloFormShared/form-ricorso-cassazione/form-ricorso-cassazione.component";
import {
  FormCoterziViewComponent
} from "../../../../tributario/fascicoloFormShared/form-coterzi/view/form-coterzi-view.component";
import {FormCoterziComponent} from "../../../../tributario/fascicoloFormShared/form-coterzi/form-coterzi.component";
import {
  FormImmobiliareViewComponent
} from "../../../../tributario/fascicoloFormShared/form-immobiliare/view/form-immobiliare-view.component";
import {
  FormImmobiliareComponent
} from "../../../../tributario/fascicoloFormShared/form-immobiliare/form-immobiliare.component";
import {
  FormMobiliareComponent
} from "../../../../tributario/fascicoloFormShared/form-mobiliare/form-mobiliare.component";
import {
  FormMobiliareViewComponent
} from "../../../../tributario/fascicoloFormShared/form-mobiliare/view/form-mobiliare-view.component";
import {
  FormMediazioneViewComponent
} from "../../../../tributario/fascicoloFormShared/form-mediazione/view/form-mediazione-view.component";
import {
  FormMediazioneComponent
} from "../../../../tributario/fascicoloFormShared/form-mediazione/form-mediazione.component";
import {
  FormRecuperoCreditiStragiudizialeComponent
} from "../../../../tributario/fascicoloFormShared/form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component";
import {
  FormRecuperoCreditiStragiudizialeViewComponent
} from "../../../../tributario/fascicoloFormShared/form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component";
import {FascicoloParere} from "../../../../tributario/fascicoloFormShared/models/parere/fascicolo-parere";
import {FascicoloAppello} from "../../../../tributario/fascicoloFormShared/models/appello/fascicolo-appello";
import {FascicoloOrdinario} from "../../../../tributario/fascicoloFormShared/models/ordinario/fascicolo-ordinario";
import {
  FascicoloRicorsoCassazione
} from "../../../../tributario/fascicoloFormShared/models/ricorso-cassazione/fascicolo-ricorso-cassazione";
import {FascicoloCoTerzi} from "../../../../tributario/fascicoloFormShared/models/coterzi/fascicolo-coterzi";
import {
  FascicoloImmobiliare
} from "../../../../tributario/fascicoloFormShared/models/immobiliare/fascicolo-immobiliare";
import {FascicoloMobiliare} from "../../../../tributario/fascicoloFormShared/models/mobiliare/fascicolo-mobiliare";
import {FascicoloMediazione} from "../../../../tributario/fascicoloFormShared/models/mediazione/fascicolo-mediazione";
import {
  FascicoloRecuperoCreditiStragiudiziale
} from "../../../../tributario/fascicoloFormShared/models/recupero-crediti-stragiudiziale/fascicolo-recuperocreditistragiudiziale";
import { FascicoloGenerico } from "src/app/tributario/fascicoloFormShared/models/generico/fascicolo-generico";
import { FormGenericoViewComponent } from "src/app/tributario/fascicoloFormShared/form-generico/view/form-generico-view.component";
import { FormGenericoComponent } from "src/app/tributario/fascicoloFormShared/form-generico/form-generico.component";


export function getComponentFromFormTenantTributario(idFormTenant, view = false) {

  switch (idFormTenant) {
    case 'TriPar_PRD': {
      return view ? FormParereViewComponent : FormParereComponent; // "PARERE",
    }
    case 'TriApp_PRD': {
      return view ? FormAppelloViewComponent : FormAppelloComponent; // "APPELLO",
    }
    case 'TriOrd_PRD': {
      return view ? FormOrdinarioViewComponent : FormOrdinarioComponent; // "ORDINARIO",
    }
    case 'TriRca_PRD': {
      return view ? FormRicorsoCassazioneViewComponent : FormRicorsoCassazioneComponent; // "RICORSO IN CASSAZIONE",
    }
    case 'TriEpt_PRD': {
      return view ? FormCoterziViewComponent : FormCoterziComponent; // "ESECUZIONE C/O TERZI",
    }
    case 'TriEim_PRD': {
      return view ? FormImmobiliareViewComponent : FormImmobiliareComponent; // "ESECUZIONE IMMOBILIARE",
    }
    case 'TriEmo_PRD': {
      return view ? FormMobiliareViewComponent : FormMobiliareComponent; // "ESECUZIONE MOBILIARE",
    }
    case 'TriMed_PRD': {
      return view ? FormMediazioneViewComponent : FormMediazioneComponent; // "MEDIAZIONE",
    }
    case 'TriRec_PRD': {
      // "RECUPERO CREDITI STRAGIUDIZIALE"
      return view ? FormRecuperoCreditiStragiudizialeViewComponent : FormRecuperoCreditiStragiudizialeComponent;
    }
    case 'TriGen_PRD': {
      return view ? FormGenericoViewComponent : FormGenericoComponent;
    }
  }
}

export function getFascicoloTriburario(genericFascicolo): any {
  let fascicolo;
  switch (genericFascicolo) {
    case 'parere': {
      fascicolo = new FascicoloParere();
      break;
    }
    case 'appello': {
      fascicolo = new FascicoloAppello();
      break;
    }
    case 'ordinario': {
      fascicolo = new FascicoloOrdinario();
      break;
    }
    case 'ricorsocassazione': {
      fascicolo = new FascicoloRicorsoCassazione();
      break;
    }
    case 'esecuzionepressoterzi': {
      fascicolo = new FascicoloCoTerzi();
      break;
    }
    case 'esecuzioneimmobiliare': {
      fascicolo = new FascicoloImmobiliare();
      break;
    }
    case 'esecuzionemobiliare': {
      fascicolo = new FascicoloMobiliare();
      break;
    }
    case 'mediazione': {
      fascicolo = new FascicoloMediazione();
      break;
    }
    case 'recuperocreditistragiudiziale': {
      fascicolo = new FascicoloRecuperoCreditiStragiudiziale();
      break;
    }
    case 'genericogiudiziale': {
      fascicolo = new FascicoloGenerico();
      break;
    }
  }
  return fascicolo;
}
